(() => {
  document.querySelectorAll('.pt-full-film').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const opener = root.querySelector('[data-full-film-open]');
    const dialog = root.querySelector('dialog');
    const video = root.querySelector('[data-full-film-video]');
    const close = root.querySelector('[data-full-film-close]');
    if (!opener || !dialog || !video || !close || typeof dialog.showModal !== 'function') return;
    let previousOverflow = '';
    let resumeBackground = false;
    const background = document.querySelector('[data-pt-hero-video]');
    opener.addEventListener('click', (event) => {
      event.preventDefault();
      if (dialog.open) return;
      previousOverflow = document.documentElement.style.overflow;
      resumeBackground = Boolean(background && !background.paused);
      if (background) background.pause();
      dialog.showModal();
      document.documentElement.style.overflow = 'hidden';
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      close.focus();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      video.pause();
      video.removeAttribute('src');
      video.load();
      document.documentElement.style.overflow = previousOverflow;
      opener.focus();
      if (resumeBackground && !matchMedia('(prefers-reduced-motion: reduce)').matches) background.play().catch(() => {});
    });
  });
})();
